<template>
    <ul class="nav nav-tabs bg-transparent tab-lemon">
        <li class="nav-item">
            <a
                :class="this.activeOption == 'anaylics-root' ? 'nav-link active disabled' : 'nav-link'"
                @click.prevent="navigate('Analytics', 'analytics-root')"
            >Inicio</a>
        </li>
        <li class="nav-item">
            <a
                :class="this.activeOption == 'analytics-breakdown-day' ? 'nav-link active disabled' : 'nav-link'"
                @click.prevent="navigate('Analytics', 'analytics-breakdown-day')"
            >Desglose analítico de guías</a>
        </li>
        <li class="nav-item">
            <a
                :class="this.activeOption == 'analytics-grouped' ? 'nav-link active disabled' : 'nav-link'"
                @click.prevent="navigate('Analytics', 'analytics-grouped')"
            >Analítica de guías agrupada</a>
        </li>
        <li class="nav-item">
            <a
                :class="this.activeOption == 'analytics-bus-companies-breakdown-day' ? 'nav-link active disabled' : 'nav-link'"
                @click.prevent="navigate('Analytics', 'analytics-bus-companies-breakdown-day')"
            >Desglose analítico de compañías de buses</a>
        </li>
    </ul>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    methods: {
        async navigate(tab, option) {
            await this.$store.dispatch("layout/setActiveTabAndOption", {tab: tab, option: option})
        }
    },
    computed: {
      ...mapGetters(['activeTab', 'activeOption'])
  },
}
</script>